import { useCallback } from 'react';
import { useToast } from './use-toast';

export const useApiError = () => {
  const { toast } = useToast();

  const handleError = useCallback(
    (error) => {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong';

      toast({
        variant: 'destructive',
        message: `Error: ${message}`,
      });

      return message;
    },
    [toast]
  );

  return { handleError };
};
